import React, { ReactNode } from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

import { NumericField } from '@paragon/material';

import { SoonLabel } from './SoonLabel';

interface Props {
  readonly label: ReactNode;
  readonly enabled: boolean;
  readonly value: number;
  readonly onToggle?: (enabled: boolean) => void;
  readonly onValueChange?: (value: number) => void;
  readonly disabled?: boolean;
  readonly soon?: boolean;
  readonly unit?: string;
  readonly valueAriaLabel?: string;
}

export function CostTermRow({
  label,
  enabled,
  value,
  onToggle,
  onValueChange,
  disabled,
  soon,
  unit = '$',
  valueAriaLabel,
}: Props) {
  const controlsDisabled = disabled || soon;
  const inputDisabled = controlsDisabled || !enabled;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <FormControlLabel
        sx={{ flex: 1, mr: 0 }}
        control={
          <Checkbox
            checked={enabled && !soon}
            disabled={controlsDisabled}
            onChange={(_event, checked) => onToggle?.(checked)}
          />
        }
        label={soon ? <SoonLabel>{label}</SoonLabel> : label}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <NumericField
          value={value}
          onSubmit={(newValue) => onValueChange?.(newValue)}
          min={0}
          numberOfDecimals={2}
          disabled={inputDisabled}
          fullWidth={false}
          sx={{ width: 72 }}
          slotProps={{ htmlInput: { 'aria-label': valueAriaLabel } }}
        />
        <Typography variant="body2" color={inputDisabled ? 'text.disabled' : 'text.secondary'}>
          {unit}
        </Typography>
      </Box>
    </Box>
  );
}
